import { PRODUCTS_URL, PRODUCT_CATEGORIES_URL, PRODUCT_URL, SLUG_PRODUCT_URL } from "../../../../../constants";
import { apiSlice } from "./apiSlice";

export const productApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: ({ limit, page, quantity, filters , search}) => {
        const params = { 
          limit, 
          page, 
          quantity, 
          category : 5, 
          rank: 1,
          sales_count: 1,
          ...(search && { search })  
        };

        // If filters exist, include them in the request
        if (filters) {
          if (filters.price) {
            params['filters[price][value]'] = filters.price.value;
            params['filters[price][operation]'] = filters.price.operation;
            if (filters.price.limitValue) {
              params['filters[price][limitValue]'] = filters.price.limitValue;
            }
          }
          if (filters.discount) {
            params['filters[discount][value]'] = filters.discount.value;
            params['filters[discount][operation]'] = filters.discount.operation;
            if (filters.discount.limitValue) {
              params['filters[discount][limitValue]'] = filters.discount.limitValue;
            }
          }

          if (filters.category) {
            params['filters[sub_category_id][value]'] = filters.category.value;
            params['filters[sub_category_id][operation]'] = filters.category.operation;
          }

          if (filters.vendor) {
            params['filters[user_id][value]'] = filters.vendor.value;
            params['filters[user_id][operation]'] = filters.vendor.operation;
          }
        }

        return {
          url: PRODUCTS_URL,
          params,
        };
      },
      keepUnusedDataFor: 5,
    }),
    getProduct: builder.query({
      query: ({product}) => {
          return {
            url: `${PRODUCT_URL}/${product}`
          }
      },
      keepUnusedDataFor: 5,
    }),
    getProductBySlug: builder.query({
      query: ({slug}) => {
          return {
            url: `${SLUG_PRODUCT_URL}/${slug}`
          }
      },
      keepUnusedDataFor: 5,
    }),
    getProductCategories: builder.query({
      query: () => {
        return {
          url: PRODUCT_CATEGORIES_URL,
        };
      },
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetProductsQuery,useGetProductQuery,useGetProductBySlugQuery,useGetProductCategoriesQuery } = productApiSlice;
